import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'expertepool',
  heading: 'Trainer:innenpool',
  subheading: 'Verteilung nach Cluster in %',
  columnLabels: {
    name: 'Name',
    anrede: 'Anrede',
    titel: 'Titel',
    cluster: 'Cluster',
    expertenTags: 'Expert:in Tag',
    auslastung: 'Auslastung',
    gueltigkeitszeitraeume: 'Gültigkeiten',
    gesellschaft: 'Gesellschaft',
    email: 'E-Mail',
    sapId: 'SAP-ID',
  },
} as const;

export type Content = typeof content;
